import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

// Banner discret care apare cand device-ul isi pierde conexiunea.
// Dispare automat la revenirea online. Nu blocheaza interactiunea cu app-ul;
// UI-ul curent se incarca din bundle-ul local (nu mai avem crash-ul
// "Webpage not available" al WebView-ului de cand nu mai folosim server.url).
export default function OfflineBanner() {
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 'calc(env(safe-area-inset-top, 0px) + 8px)',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: 'rgba(25, 48, 48, 0.95)',
        color: '#fff',
        padding: '8px 16px',
        borderRadius: '999px',
        fontSize: '13px',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <WifiOff size={14} />
      <span>Fără conexiune la internet</span>
    </div>
  );
}
